export default __webpack_public_path__ + "static/media/eclipse.814fac21.png";